import { render, staticRenderFns } from "./VolumeIcon.vue?vue&type=template&id=4164cb66&"
import script from "./VolumeIcon.vue?vue&type=script&lang=js&"
export * from "./VolumeIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports